/**
 * Loading the presenter photo library — the NETWORK half of
 * features/presenter-photos, split from ./store.ts for the reason
 * features/ai-models/load.ts gives (a component reaching `core/api.ts` drags
 * `import.meta.env` into the server's e2e typecheck graph).
 */
import { fetchPresenterPhotos } from "../../core/api.js";

import { presenterPhotos } from "./store.js";

let inflight: Promise<void> | null = null;

/**
 * (Re)load the library. Coalesces concurrent callers and never throws: a
 * failed load keeps whatever the store already holds — an empty list on
 * first load, which the thumbnail panel reads as "no library".
 */
export function loadPresenterPhotos(): Promise<void> {
  if (inflight !== null) return inflight;
  inflight = fetchPresenterPhotos()
    .then((response) => presenterPhotos.getState().setPhotos(response.photos))
    .catch(() => {
      /* keep what we have; the next open retries */
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
